import { getLocalObjectStorage } from '@/function/function'

const getters = {
  user: (state)  => {
    try {
      if (state && state.user.userInfo.uuid) {
        return state.user.userInfo
      } else {
        let userStorage = getLocalObjectStorage('user')
        return userStorage && userStorage.user.userInfo ? userStorage.user.userInfo : null
      }
    } catch(e) {
      return null
    }
  },
  elderly: (state) => {
    try {
      if (state.family.elderly) {
        return state.family.elderly
      } else {
        const storage = getLocalObjectStorage('family')
        return storage && storage.family.elderly ? storage.family.elderly : null
      }
    } catch(e) {
      return null
    }
  },
  currentElderly: (state) => {
    try {
      if (state.family.currentElderly) {
        return state.family.currentElderly
      } else {
        const storage = getLocalObjectStorage('family')
        return storage && storage.family.currentElderly ? storage.family.currentElderly : null
      }
    } catch(e) {
      return null
    }
  },
  // 键盘高度
  keyboardHeight: (state) => {
    try {
      const storage = getLocalObjectStorage('common')
      return storage && storage.common.keyboardHeight ? storage.common.keyboardHeight : null
    } catch(e) {
      return null
    }
  }
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js